/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 09:21:28
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  PEIManagementListParams,
  getPEIManagementList,
  getPEIManagementDetail,
  getPEIManagementSubmit,
  getRemove,
  SubmitParams,
  DetailParams,
} from '../../../services/PEIManagement'

// 列表
export const getPEIManagementListAsync = createAsyncThunk<
  void,
  PEIManagementListParams,
  RootThunkApi<void>
>('PEIManagement/getPEIManagementListAsync', async (params, api) => {
  return sendAsync(getPEIManagementList(params), api)
})

// 详情
export const getPEIManagementDetailAsync = createAsyncThunk<
  void,
  DetailParams,
  RootThunkApi<void>
>('PEIManagement/getPEIManagementDetailAsync', async (params, api) => {
  return sendAsync(getPEIManagementDetail(params), api)
})

// 保存编辑
export const getPEIManagementSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>('PEIManagement/getPEIManagementSubmitAsync', async (params, api) => {
  return sendAsync(getPEIManagementSubmit(params), api)
})

// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'PEIManagement/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
